import { render } from "./SetupPassword.vue?vue&type=template&id=79cd53d0&scoped=true"
import script from "./SetupPassword.vue?vue&type=script&lang=js"
export * from "./SetupPassword.vue?vue&type=script&lang=js"

import "./SetupPassword.vue?vue&type=style&index=0&id=79cd53d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cd53d0"]])

export default __exports__